module.exports = __webpack_public_path__ + "img/DHL_logo_rgb-1024x226.a07ebfe3.png";